import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import { Procedure, ProviderSettings } from '@dataTypes/procedureSettings.type'
import {
  procedureSettingsData,
  providerSettingsData,
} from '@assets/mockdata/Procedure/procedureSettingsData'
import { logger } from '@utils/safeLogger'

let mockProcedures: Procedure[] = [...procedureSettingsData]
let mockProviderSettings: ProviderSettings = { ...providerSettingsData }
// const providersList: Provider[] = [...mockProviders]

export const getAllProcedures = createAsyncThunk<Procedure[], void>(
  'api/procedures/get/all',
  async (_, { rejectWithValue }) => {
    try {
      return mockProcedures
    } catch (error) {
      return rejectWithValue('Failed to fetch procedures')
    }
  },
)

export const addProcedure = createAsyncThunk<Procedure, Procedure>(
  'api/procedures/add/procedure',
  async (newProcedure, { rejectWithValue }) => {
    try {
      mockProcedures = [...mockProcedures, newProcedure]
      return newProcedure
    } catch (error) {
      return rejectWithValue('Failed to add procedure')
    }
  },
)

export const updateProcedure = createAsyncThunk<
  Procedure,
  { code: string; body: Partial<Procedure> }
>(
  'api/procedures/update/procedure',
  async ({ code, body }, { rejectWithValue }) => {
    try {
      mockProcedures = mockProcedures.map((procedure) =>
        procedure.code === code ? { ...procedure, ...body } : procedure,
      )

      const updatedProcedure = mockProcedures.find(
        (procedure) => procedure.code === code,
      )
      if (!updatedProcedure) {
        logger.error('Procedure not found')
        throw new Error(`Procedure with code ${code} not found`)
      }

      return updatedProcedure
    } catch (error) {
      logger.error('Update Error', error)
      return rejectWithValue('Failed to update procedure')
    }
  },
)

export const removeProcedure = createAsyncThunk<string, string>(
  'api/procedures/remove/procedure',
  async (code, { rejectWithValue }) => {
    try {
      mockProcedures = mockProcedures.filter(
        (procedure) => procedure.code !== code,
      )
      return code
    } catch (error) {
      return rejectWithValue('Failed to remove procedure')
    }
  },
)

export const getProviderSettings = createAsyncThunk<ProviderSettings>(
  'api/providers/get/ProviderSettings',
  async (_, { rejectWithValue }) => {
    try {
      return mockProviderSettings
    } catch (error) {
      return rejectWithValue('Failed to fetch provider settings')
    }
  },
)

export const saveProviderSettings = createAsyncThunk<
  ProviderSettings,
  ProviderSettings
>(
  'api/providers/save/ProviderSettings',
  async (updatedSettings, { rejectWithValue }) => {
    try {
      mockProviderSettings = { ...updatedSettings }
      return mockProviderSettings
    } catch (error) {
      return rejectWithValue('Failed to save provider settings')
    }
  },
)

// export const getProvidersList = createAsyncThunk<Provider[]>(
//   'api/providers/get/ProvidersList',
//   async (_, { rejectWithValue }) => {
//     try {
//       return providersList
//     } catch (error) {
//       return rejectWithValue('Failed to fetch providers list')
//     }
//   },
// )

export const updateProviderSettingsDraft = createAction<ProviderSettings>(
  'api/providers/update/SettingsDraft',
)
